import * as React from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import isNil from 'lodash/isNil';
import isArray from 'lodash/isArray';
import './cn-readonly.scss';
var isEmpty = function (value) {
    if (isNil(value)) {
        // null or undefined
        return true;
    }
    if (value === '') {
        return true;
    }
    if (isArray(value) && !value.length) {
        return true;
    }
    return false;
};
export var CnReadonly = function (props) {
    var children = props.children, emptyRender = props.emptyRender, isOverflowEllipsis = props.isOverflowEllipsis;
    var classes = cx({
        'cn-ui-m-readonly': true,
        'cn-ui-m-readonly-ellipsis': isOverflowEllipsis,
    });
    var itemRender = function () {
        if (isEmpty(children)) {
            return emptyRender();
        }
        return children;
    };
    return withNativeProps(props, React.createElement("div", { className: classes }, itemRender()));
};
CnReadonly.displayName = 'CnReadonly';
CnReadonly.defaultProps = {
    isOverflowEllipsis: true,
    emptyRender: function () { return '- -'; },
};
export var CnReadOnly = CnReadonly;
